import React, { Component } from 'react';
import { Collapse, Button, CardBody, Card } from 'reactstrap';
import legalFormKeys from '../data/legalFormKeys';
import { translate } from 'react-i18next';

class LegalForms extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { collapse: false };
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  render() {
    return (
      <Card>
        <div className="card-header">
          <h5 className="mb-0">
            <Button color="link" onClick={this.toggle}>{this.props.t('sectionTitle')}</Button>
          </h5>
        </div>
        <Collapse isOpen={this.state.collapse}>
          <CardBody>
            <div className="table-responsive">
              <table className="table table-striped table-sm">
                <thead>
                  <tr>
                    <th>{this.props.t('columnOneTitle')}</th>
                    <th>{this.props.t('columnTwoTitle')}</th>
                  </tr>
                </thead>
                <tbody>
                  { legalFormKeys.map((item) => 
                    <tr key={ item.id.toString() } >
                      <th>{ item.id }</th>
                      <td>{ this.props.t(`${item.id}.description`) }</td>
                    </tr>
                    )}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Collapse>
      </Card>
    );
  }
}

export default translate('LegalForms')(LegalForms);



// WEBPACK FOOTER //
// ./src/components/LegalForms.jsx